import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiShivaService } from '@core/apis/api-shiva.service';
import { ToastrService } from 'ngx-toastr';

import { SignalsService } from '@core/services/signals.service';

@Component({
  selector: 'app-provider-orders-import-modal',
  templateUrl: './provider-orders-import-modal.component.html',
  styles: []
})
export class ProviderOrdersImportModalComponent implements OnInit {
  public uploadUrl: string;
  public uploadSuccessful = null;
  public errStr: string;
  public jobName = 'Import de commandes fournisseur';

  constructor(
    private apiShiva: ApiShivaService,
    public modal: NgbActiveModal,
    public signalsService: SignalsService,
    private toastr: ToastrService,
  ) {}

  public ngOnInit(): void {
    this.uploadUrl = this.apiShiva.provider_orders.import_url();
  }

  public onUpload() {
    this.uploadSuccessful = null;
  }

  public onSuccessfullUpload(res) {
    this.uploadSuccessful = true;
    // the response should contains the job_id
    this.signalsService.broadcastJobStart(this.jobName, res.job_id);
  }

  public onFailedUpload(res) {
    this.uploadSuccessful = false;
    this.toastr.error(res['detail']);
    this.errStr = this._formatError(res);
    this.toastr.error(this.errStr);
  }

  public close() {
    if (this.uploadSuccessful) {
      this.modal.close();
    } else {
      this.modal.dismiss();
    }
  }
  private _formatError(res) {
    const errType = res.context['error_type'];
    let errStr;
    switch (errType) {
        case 'no_source_file':
        errStr = `Aucun fichier n'a été reçu par le serveur.`;
        break;
    }
    return errStr;
  }

}
